import type { InjectionKey } from 'vue'

/** Provided by the first CMS panel on a page so its images load eagerly as the LCP candidate. */
export const MEDIA_PRIORITY_KEY: InjectionKey<boolean> = Symbol('media-priority')
